import { Box, Typography } from '@mui/material'
import { useCountdown } from 'utils/countdown'

const TimeUnit = ({ value, label, compact }) => (
  <Box sx={{ textAlign: 'center', flex: 1, minWidth: compact ? 40 : 48 }}>
    <Box
      sx={{
        bgcolor: (t) => t.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'grey.100',
        borderRadius: 2,
        py: compact ? 0.75 : 1,
        px: 0.5,
        border: '1px solid',
        borderColor: (t) => t.palette.mode === 'dark' ? 'rgba(255,255,255,0.12)' : 'grey.200',
      }}
    >
      <Typography
        variant={compact ? 'body1' : 'h6'}
        fontWeight={800}
        sx={{ lineHeight: 1, fontVariantNumeric: 'tabular-nums', color: 'text.primary' }}
      >
        {String(value).padStart(2, '0')}
      </Typography>
    </Box>
    <Typography
      variant="caption"
      sx={{
        mt: 0.5,
        display: 'block',
        fontSize: '0.6rem',
        fontWeight: 700,
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        color: 'text.secondary',
      }}
    >
      {label}
    </Typography>
  </Box>
)

const OfferCountdown = ({ targetDate, label = 'Ends in', dateTime, compact = false, variant = 'light' }) => {
  const { days, hours, minutes, seconds, expired } = useCountdown(targetDate)

  if (!targetDate) return null

  if (expired) {
    return (
      <Box>
        <Typography variant="caption" fontWeight={700} color="error.main">
          Offer ended
        </Typography>
      </Box>
    )
  }

  const labelColor = variant === 'dark' ? 'rgba(255,255,255,0.85)' : 'text.secondary'

  return (
    <Box>
      <Typography
        variant="caption"
        fontWeight={700}
        sx={{ color: labelColor, textTransform: 'uppercase', letterSpacing: 1, mb: 1, display: 'block' }}
      >
        {label}
      </Typography>
      <Box display="flex" gap={compact ? 0.75 : 1}>
        <TimeUnit value={days} label="Days" compact={compact} />
        <TimeUnit value={hours} label="Hrs" compact={compact} />
        <TimeUnit value={minutes} label="Min" compact={compact} />
        <TimeUnit value={seconds} label="Sec" compact={compact} />
      </Box>
      {dateTime && (
        <Typography
          variant="caption"
          sx={{ mt: 1, display: 'block', color: labelColor, fontWeight: 600 }}
        >
          {dateTime}
        </Typography>
      )}
    </Box>
  )
}

export default OfferCountdown
